import { render, staticRenderFns } from "./LiveOrders.vue?vue&type=template&id=71ce8eb6&scoped=true"
import script from "./LiveOrders.vue?vue&type=script&lang=js"
export * from "./LiveOrders.vue?vue&type=script&lang=js"
import style0 from "./LiveOrders.vue?vue&type=style&index=0&id=71ce8eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce8eb6",
  null
  
)

export default component.exports